import { $ } from './dom.js';

export function initFormFeedback() {
  const form = $('.offline-form');
  if (!form) return;
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!form.checkValidity()) return form.reportValidity();
    $('.offline-success', form)?.classList.add('is-visible');
  });
}
